const ItemInfo = ({
  children,
  label,
  grid = "col-12 col-sm-6 col-lg-4 col-xl-3",
}) => {
  return (
    <div className={grid}>
      <p className="border-bottom">
        {label && <label className="text-info d-block">{label}</label>}
        {children}
      </p>
    </div>
  );
};

export default ItemInfo;
